export enum PromotionTypeEnum {
  REGULAR = 'regular',
  INSTALLMENT = 'installment',
  INSTALLMENT_FLEX = 'installment_flex',
  LEASING = 'leasing'
}
